export const invoiceUploadStatus = {
    IN_PROGRESS: 0,
    SUCCESS: 1,
    FAILED: 2,
}